"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
class Logger {
    constructor(namespace, transport) {
        this.namespace = namespace;
        this.transport = transport;
    }
    info(message) {
        this.transport.send('info', message, { namespace: this.namespace });
    }
    warning(message) {
        this.transport.send('warning', message, { namespace: this.namespace });
    }
    debug(message) {
        this.transport.send('debug', message, { namespace: this.namespace });
    }
    error(message) {
        this.transport.send('error', message, { namespace: this.namespace });
    }
    critical(message) {
        this.transport.send('error', message, { namespace: this.namespace });
    }
    clone(namespace) {
        return new Logger(namespace, this.transport);
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map